<app-title-bar titleText="i18n.base.two-factor-authentication.recovery.header"></app-title-bar>
<div class="two-fa-wrapper">
  <div class="row">
    <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
      <ejs-stepper stepType="Default" [activeStep]="stepIndex" [readOnly]="true">
        <e-steps>
          <e-step></e-step>
          <e-step></e-step>
          <e-step></e-step>
          <e-step></e-step>
          <e-step></e-step>
        </e-steps>
      </ejs-stepper>
    </div>
  </div>
  <div class="row mt-4">
    @switch (stepIndex) {
      @case (0) {
        <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
          <app-step-authenticate [data]="stepAuthenticateData" (next)="requestRecoveryCode($event)" [loading]="loading"></app-step-authenticate>
        </div>
      }
      @case (1) {
        <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
          <app-step-verify-recovery-code (next)="requestQrCode($event)" (resendRecoveryCode)="resendRecoveryCode()"></app-step-verify-recovery-code>
        </div>
      }
      @case (2) {
        <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
          <app-step-qrcode [qrData]="qrData" (qrCodeRegistered)="onQrCodeRegistered()" alternateDescription="i18n.base.two-factor-authentication.recovery.qr-description"></app-step-qrcode>
        </div>
      }
      @case (3) {
        <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
          <app-step-verify-registration [loading]="loading" (next)="validateRegistration($event)" (back)="navigateBack()"></app-step-verify-registration>
        </div>
      }
      @case (4) {
        <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
          <app-step-registration-successful></app-step-registration-successful>
        </div>
      }
    }
  </div>
</div>
